//Copied from ServerSentEventNotificationKeyType.cs
export enum SSENotificationKey {
    None = 0,
    TerminateContractsByTemplate = 1,
    TerminateContractsByTemplateError = 2,
    FileUploaded = 3,
    ResendActivationFailed = 4,
    ResendActivationSuccess = 5,
    FileDeleted = 6,
    /** Gets triggered on (pre)cutoff */
    ManualCutOffSuccess = 7,
    /** Gets triggered on (pre)cutoff */
    ManualCutOffFailed = 8,
    CutOffStarted = 9,
    CutOffCompleted = 10,
    CreateOrderSucceeded = 11,
    CreateOrderFailed = 12,
    ServicePointDeactivationErrorOpenOrders = 13,
    AssignContractToCompanyFailed = 14,
    PricingAgreementsAddedFromFile = 15,
    ImportStatement = 16,
    ResolvingAfasErrorsFinished = 17,
    ReimbursementsGenerated = 18,
    ImportStatementError = 19,
    EpacAdvancesImported = 20,
    StatementInvoiceCreated = 21,
    ImportDistributorsSuccess = 22,
    ImportDistributorsFailed = 23,
    ImportAdministrativeOrdersSuccess = 24,
    ImportAdministrativeOrdersFailed = 25,
    ActiveCompanyChanged = 26,
    CreateActionNote = 27,
    JobMetadataUpdated = 28,
    FeatureFlagStateChanged = 29,
    MessageUpdated = 30,
}
